// 文件加载
function loadFile(filePath) {
    return new Promise((resolve, reject) => {
        var loader = new esmap.ESFileLoader();
        loader.load(
            // 资源的URL
            filePath,
            // onLoad回调
            function (data) {
                resolve(data);
            },
            null,
            // onError回调
            function (err) {
                reject(err);
            }
        );
    })
}
// 地图墨卡托坐标转经纬度坐标
function mercator2lonLat(mercatorX, mercatorY) {
    var xy = [];
    var x = mercatorX / 20037508.342789 * 180;
    var y = mercatorY / 20037508.342789 * 180;
    y = 180 / Math.PI * (2 * Math.atan(Math.exp(y * Math.PI / 180)) - Math.PI / 2);
    xy.push(x);
    xy.push(y);
    return xy;
}


// 经纬度坐标转地图墨卡托坐标
function lonLat2Mercator(lon, lat) {
    var xy = []
    var x = (lon * 20037508.342789) / 180
    var y = Math.log(Math.tan(((90 + lat) * Math.PI) / 360)) / (Math.PI / 180)
    y = (y * 20037508.34789) / 180
    xy.push(x)
    xy.push(y)
    return xy
}

// 经纬度浮点数转换度数表达
function formatDegree(value) {
    if (value != null && value != '') {
        value = Math.abs(value);
        var v1 = Math.floor(value);//度
        var v2 = Math.floor((value - v1) * 60);//分
        var v3 = Math.round((value - v1) * 3600 % 60);//秒
        return [v1, v2, v3];
    }
}

function lonLatFormatFloat(latlng) {
    //以字符串形式输入经纬度的转换
    var du = latlng.substring(0, latlng.indexOf("°")) * 1;
    var fen = latlng.substring(latlng.indexOf("°")+1, latlng.indexOf("′")) * 1;
    var miao = latlng.substring(latlng.indexOf("′")+1, latlng.indexOf("″")) * 1;
    if(du<0) return -(Math.abs(du)+(fen+(miao/60))/60);
    return du+(fen+(miao/60))/60;
}

// 计算两点距离
function getDistance(p1, p2) {
    if (p1 == undefined || p2 == undefined) return;
    return Math.abs(Math.sqrt(Math.pow(p1.x - p2.x, 2) + Math.pow(p1.y - p2.y, 2)))
}

// 经纬数组坐标转换GCJ02墨卡托
function lonLatCoordsToMc(list) {
    let result = []
    for(let i = 0; i < list.length; i++) {
        // let gcj02 = esmap.ESMapUtil.WGS84ToGCJ02([list[i][0], list[i][1]]);
        let mc = lonLat2Mercator(list[i][0], list[i][1]);
        result.push({ x: mc[0], y: mc[1]});
    }
    return result
}

/**
* 函数节流方法
* @param Function fn 延时调用函数
* @param Number delay 延迟多长时间
* @param Number atleast 至少多长时间触发一次
* @return Function 延迟执行的方法
*/
function throttleFunc(fn, delay, atleast, obj, context) {
    let timer = null;
    let previous = null;
    return function () {
        let now = + new Date();
        if (!previous) previous = now;
        if (now - previous > atleast) {
            fn(obj, context);
            // 重置上一次开始时间为本次结束时间
            previous = now;
        } else {
            clearTimeout(timer);
            timer = setTimeout(function () {
                fn(obj, context);
            }, delay);
        }
    }
}

export {
    loadFile,
    mercator2lonLat,
    lonLat2Mercator,
    lonLatCoordsToMc,
    formatDegree,
    lonLatFormatFloat,
    getDistance,
    throttleFunc
}